module.exports = __webpack_public_path__ + "static/media/criteria-9.1-rsp.f97b6827.jpg";